import { CHAPTER_ACTIONS } from "./action";

// ----------------------------------------------------------------------

const chapterInitialState = {
  data: [],
  chapterData: {},
  loading: false,
  pagination: {
    currentPage: 0,
    totalPages: 1,
    perPage: 1,
    total: 1,
  },
};

// eslint-disable-next-line default-param-last
export function chapterReducer(state = chapterInitialState, action) {
  switch (action.type) {
    case CHAPTER_ACTIONS.SET_STATE:
      return { ...state, ...action.payload };
    case CHAPTER_ACTIONS.DESTROY:
      return chapterInitialState;
    default:
      return state;
  }
}
